<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <products-title />
    </b-col>
    <b-col
      cols="12"
      md="6"
    >
      <products-categories-card />
    </b-col>
    <b-col
      cols="12"
      md="12"
    >
      <product-summary />
    </b-col>
    <b-col
      cols="12"
      md="12"
    >
      <products-content />
    </b-col>
    <b-col
      cols="12"
      md="12"
    >
      <products-extras />
    </b-col>
    <b-col
      cols="12"
      md="12"
    >
      <products-ordering-card />
    </b-col>
    <b-col
      cols="12"
      md="12"
    >
      <notes-card />
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import ProductsTitle from '@/views/Admin/Products/Elements/TitleCard.vue'
import ProductSummary from '@/views/Admin/Products/Elements/SummaryCard.vue'
import ProductsContent from '@/views/Admin/Products/Elements/ContentCard.vue'
import ProductsCategoriesCard from '@/views/Admin/Products/Elements/CateogriesCard.vue'
import ProductsOrderingCard from '@/views/Admin/Products/Elements/OrderingCard.vue'
import ProductsExtras from '@/views/Admin/Products/Elements/ExtrasCard.vue'
import NotesCard from '@/views/Admin/Products/Elements/NotesCard.vue'

export default {
  name: 'ProductInfo',
  components: {
    NotesCard,
    ProductsExtras,
    ProductsOrderingCard,
    ProductsCategoriesCard,
    ProductsContent,
    ProductSummary,
    ProductsTitle,
    BRow,
    BCol,
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
